import { ReservedValueStoreKeys } from '../../../services/JWeb/JWebEnums';
import {
  getJWebAppVersion,
  getJWebAppVersionFull,
  getPlatform,
  ValueStoreFacade
} from '../../../services/JWeb';
import IApplicationService from '../../../services/applicationService/IApplicationService';
import bindAllMethods from '../../../utils/bindAllMethods';
import { internalLogger } from '../clientOsLogger';
import { container } from 'tsyringe';
import { AppInterfaceV1Type } from './types';
import { getServices } from '../../../infra/startup';

export type AppInterfaceV1Param = {
  applicationService: IApplicationService;
};

class AppInterfaceV1 {
  private _applicationService: IApplicationService;
  private _caches = new Map<any, any>();

  constructor() {
    const services = getServices();
    this._applicationService = services.applicationService;
    bindAllMethods(this);
  }

  public getInterface(): AppInterfaceV1Type {
    const isNative = container.resolve<boolean>('IsNative');
    return {
      getClientId: () => {
        return this._applicationService.getClientId();
      },
      getAppName: () => {
        return this._applicationService.getAppName();
      },
      getAuthStack: () => {
        return this._applicationService.getAuthStack();
      },
      getPortalStack: () => {
        return this._applicationService.getPortalStack();
      },
      getAppInstanceId: async (): Promise<string | undefined> => {
        if (!this._caches.has('appInstanceId')) {
          this._caches.set(
            'appInstanceId',
            (async () => {
              if (isNative) {
                try {
                  const response = await ValueStoreFacade.get({
                    keys: [ReservedValueStoreKeys.applicationInstanceId]
                  });
                  const result = (response as any)?.result[0];

                  const appInstanceId = result?.Value || result?.value;
                  return appInstanceId;
                } catch (err) {
                  console.error('Error getting JWeb Value Store', err);
                }
              }
            })()
          );
        }
        return this._caches.get('appInstanceId');
      },
      getAppVersion: async () => {
        if (isNative) {
          return getJWebAppVersion();
        }
        internalLogger?.error('getAppVersion is only available in native');
        return '';
      },
      getAppVersionFull: async () => {
        if (isNative) {
          return getJWebAppVersionFull();
        }
        internalLogger?.error('getAppVersionFull is only available in native');
        return '';
      },
      getPlatform: async () => {
        if (isNative) {
          return getPlatform();
        }
        internalLogger?.error('getPlatform is only available in native');
        return '';
      },
      getApplicationContext: () => {
        return this._applicationService.getApplicationContext();
      }
    };
  }
}

export default AppInterfaceV1;
